// MeetingsAgendaTable.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Hoot from "../Hoot";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaTrash,
  FaEdit,
  FaPlus,
  FaChevronLeft,
  FaChevronRight,
  FaEye,
  FaCalendarAlt,
  FaThLarge,
  FaListUl,
  FaUsers,
  FaChalkboardTeacher,
  FaRegClock,
  FaMapMarkerAlt,
  FaUniversity,
  FaRegStickyNote,
  FaFilter,
} from "react-icons/fa";
import { toast } from "react-toastify";
import moment from "moment";
import "moment/locale/pt";
moment.locale("pt");

const schedulerStyles = `
:root{
  --primary:#5b5cff;
  --primary2:#7c3aed;
  --bg:#f4f6fb;
  --card:#ffffff;
  --border:#e6eaf2;
  --text:#0f172a;
  --muted:#64748b;
  --shadow: 0 14px 40px rgba(15,23,42,.08);

  --success:#16a34a;
  --warning:#f59e0b;
  --danger:#ef4444;
  --info:#3b82f6;
}

.scheduler-shell{ background:var(--bg); padding:8px; }
.scheduler-card{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  padding:12px 14px 16px;
  box-shadow: var(--shadow);
}

.scheduler-header{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  margin-bottom:10px;
}
.scheduler-title{
  font-weight:900;
  font-size:1.05rem;
  display:flex;
  align-items:center;
  gap:.6rem;
  color: var(--text);
}
.scheduler-chip{
  display:inline-flex;
  align-items:center;
  gap:.35rem;
  padding:.28rem .7rem;
  border-radius:999px;
  background:linear-gradient(135deg, rgba(91,92,255,.14), rgba(124,58,237,.12));
  color:#4338ca;
  font-size:.78rem;
  font-weight:800;
  border:1px solid rgba(91,92,255,.16);
}
.badge-mini{
  border-radius:999px;
  padding:2px 8px;
  font-size:.72rem;
  font-weight:950;
  border:1px solid rgba(226,232,240,.95);
  background: rgba(148,163,184,.06);
  color: var(--text);
}

.top-actions{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
  align-items:center;
}
.btn-soft{
  border-radius:999px;
  border:1px solid rgba(226,232,240,.95);
  background:#fff;
  font-size:.84rem;
  font-weight:900;
  padding:.42rem .8rem;
  color:var(--text);
  display:inline-flex;
  align-items:center;
  gap:.5rem;
}
.btn-soft:hover{ background: rgba(148,163,184,.10); }
.btn-primary-soft{
  border-color: rgba(91,92,255,.25);
  background: rgba(91,92,255,.10);
  color: #4f46e5;
}
.btn-primary-soft:hover{ background: rgba(91,92,255,.14); }

.scheduler-toolbar{
  padding:10px 10px;
  border-radius:14px;
  background:linear-gradient(180deg, rgba(148,163,184,0.12), rgba(148,163,184,0.06));
  border:1px solid rgba(226,232,240,.7);
  margin-bottom:12px;
}
.toolbar-row{
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  justify-content:space-between;
  gap:10px;
}
.toolbar-left{
  display:flex;
  flex-wrap:wrap;
  gap:10px;
  align-items:center;
}
.toolbar-right{
  display:flex;
  flex-wrap:wrap;
  gap:10px;
  align-items:center;
}
.view-seg{
  display:inline-flex;
  background: rgba(255,255,255,.6);
  border: 1px solid rgba(226,232,240,.9);
  border-radius: 999px;
  overflow:hidden;
}
.view-seg button{
  border:0;
  background:transparent;
  padding:7px 10px;
  font-size:.78rem;
  font-weight:950;
  color: var(--muted);
  display:flex;
  align-items:center;
  gap:6px;
}
.view-seg button.active{
  background: rgba(91,92,255,.12);
  color:#4f46e5;
}
.input-pill{
  display:flex;
  align-items:center;
  gap:8px;
  background: rgba(255,255,255,.7);
  border: 1px solid rgba(226,232,240,.9);
  border-radius: 999px;
  padding:6px 10px;
}
.input-pill input{
  border:0 !important;
  outline:none !important;
  background:transparent !important;
  font-size:.82rem;
  min-width: 220px;
}

.scheduler-main{
  display:grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap:14px;
}
@media (max-width: 980px){
  .scheduler-main{ grid-template-columns: 1fr; }
}

.month-card{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  overflow:hidden;
}
.month-head{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:12px 12px;
  border-bottom:1px solid var(--border);
  background: rgba(148,163,184,0.06);
}
.month-title{
  font-weight:950;
  font-size:1rem;
  display:flex;
  gap:10px;
  align-items:center;
  text-transform: capitalize;
}
.month-nav{
  display:flex;
  gap:8px;
  align-items:center;
}
.nav-btn{
  width:36px;height:36px;
  border-radius:14px;
  border:1px solid rgba(226,232,240,.95);
  background: rgba(255,255,255,.92);
  display:grid;
  place-items:center;
  cursor:pointer;
  font-size:.86rem;
}
.nav-btn:hover{ background: rgba(148,163,184,.12); }
.today-btn{
  border-radius:999px;
  border:1px solid rgba(91,92,255,.25);
  background: rgba(91,92,255,.10);
  color:#4f46e5;
  font-weight:950;
  padding:8px 12px;
  font-size:.78rem;
}
.today-btn:hover{ background: rgba(91,92,255,.14); }

.month-grid{ display:grid; grid-template-columns: repeat(7, 1fr); }
.month-dow{
  padding:10px 8px;
  font-size:.74rem;
  font-weight:950;
  color: var(--muted);
  border-bottom:1px solid var(--border);
  background: rgba(255,255,255,.85);
  text-transform: capitalize;
}
.month-cell{
  min-height: 112px;
  border-right:1px solid var(--border);
  border-bottom:1px solid var(--border);
  padding:8px 8px 10px;
  cursor:pointer;
  position:relative;
  background: rgba(255,255,255,.95);
}
.month-cell:nth-child(7n){ border-right:0; }
.month-cell:hover{ background: rgba(148,163,184,.06); }
.month-cell.other-month{ background: rgba(148,163,184,.04); color: rgba(107,114,128,.75); }
.month-cell.selected{
  outline: 2px solid rgba(91,92,255,.35);
  outline-offset: -2px;
  background: rgba(91,92,255,.06);
}
.day-number{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
  font-weight:950;
  font-size:.82rem;
  margin-bottom:6px;
}
.badge-today{
  font-size:.68rem;
  font-weight:950;
  color:#4f46e5;
  border:1px solid rgba(91,92,255,.25);
  background: rgba(91,92,255,.10);
  padding:2px 7px;
  border-radius:999px;
}

.dots-row{
  display:flex;
  align-items:center;
  gap:6px;
  flex-wrap:wrap;
  margin-top:6px;
}
.dot{
  width:8px;height:8px;border-radius:999px;
  background: var(--info);
  box-shadow: 0 0 0 4px rgba(2,6,23,.04);
}
.dot-agendado{ background:#3b82f6; }
.dot-realizado{ background:#16a34a; }
.dot-adiado{ background:#f59e0b; }
.dot-cancelado{ background:#ef4444; }

.more-mini{
  font-size:.72rem;
  font-weight:950;
  color:#4f46e5;
  padding:2px 8px;
  border-radius:999px;
  border:1px solid rgba(91,92,255,.18);
  background: rgba(91,92,255,.08);
}

.event-line{
  border-radius:10px;
  border:1px solid rgba(226,232,240,.9);
  background: rgba(148,163,184,.06);
  padding:5px 7px;
  font-size:.72rem;
  display:flex;
  align-items:center;
  gap:6px;
  margin-bottom:6px;
}
.event-line b{
  font-weight:950;
  max-width: 170px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.event-line time{ font-weight:900; color: rgba(15,23,42,.85); }
.event-dot{ width:8px;height:8px;border-radius:999px; background: #3b82f6; flex:0 0 auto; }
.more-link{
  font-size:.73rem;
  font-weight:950;
  color:#4f46e5;
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:4px 0;
}
.more-link:hover{ text-decoration: underline; }

.panel-card{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  overflow:hidden;
}
.panel-head{
  padding:12px 12px;
  border-bottom:1px solid var(--border);
  background: rgba(148,163,184,0.06);
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  gap:10px;
  flex-wrap:wrap;
}
.panel-title{ font-weight:950; margin:0; font-size:.95rem; }
.panel-sub{
  color: var(--muted);
  font-size:.78rem;
  margin-top:4px;
  display:flex;
  align-items:center;
  gap:8px;
  flex-wrap:wrap;
}
.panel-body{ padding:12px; }

.day-agenda{
  display:flex;
  flex-direction:column;
  gap:10px;
  max-height: 330px;
  overflow:auto;
  padding-right: 4px;
}
.agenda-item{
  border:1px solid rgba(226,232,240,.95);
  border-radius:16px;
  padding:10px 10px;
  background: rgba(148,163,184,.05);
}
.agenda-top{
  display:flex;
  justify-content:space-between;
  gap:10px;
  align-items:flex-start;
}
.agenda-title{ font-weight:950; margin:0; font-size:.86rem; line-height:1.2; }
.agenda-meta{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
  color: var(--muted);
  font-size:.76rem;
  margin-top:6px;
  align-items:center;
}
.meta-chip{
  display:inline-flex;
  align-items:center;
  gap:6px;
  border:1px solid rgba(226,232,240,.95);
  background: rgba(255,255,255,.8);
  border-radius: 999px;
  padding:4px 9px;
  font-weight:950;
}
.status-pill{
  border-radius:999px;
  padding:4px 10px;
  font-size:.72rem;
  font-weight:950;
  color:#f9fafb;
}
.st-agendado{ background:#3b82f6;}
.st-realizado{ background:#16a34a;}
.st-adiado{ background:#f59e0b;}
.st-cancelado{ background:#ef4444;}

.agenda-actions{
  display:flex;
  gap:8px;
  justify-content:flex-end;
  flex-wrap:wrap;
  margin-top:10px;
}
.icon-btn{
  width:36px;height:36px;
  border-radius:14px;
  border:1px solid rgba(226,232,240,.95);
  background: rgba(255,255,255,.85);
  display:grid;
  place-items:center;
  cursor:pointer;
  color: var(--text);
}
.icon-btn:hover{ background: rgba(148,163,184,.12); }

.section-divider{ height:1px; background: var(--border); margin: 12px 0; }

.table-title{
  font-weight:950;
  font-size:.9rem;
  margin-bottom:8px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
}
.table-responsive{
  border:1px solid rgba(226,232,240,.95);
  border-radius:16px;
  overflow:hidden;
}
.table thead th{ font-size:.74rem; font-weight:950; color: var(--muted); }
.table tbody td{ font-size:.82rem; }
.table tbody tr:hover{ background: rgba(148,163,184,.06); }
.pagination-wrap{ margin-top:10px; display:flex; justify-content:center; }

.user-pick{
  display:flex;
  flex-direction:column;
  gap:8px;
  max-height: 240px;
  overflow:auto;
  padding:8px;
  border:1px solid rgba(226,232,240,.95);
  background: rgba(148,163,184,.05);
  border-radius:16px;
}
.user-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:10px;
  padding:8px 8px;
  border-radius:14px;
  background: rgba(255,255,255,.85);
  border:1px solid rgba(226,232,240,.95);
}
.user-left{ display:flex; flex-direction:column; min-width:0; }
.user-left b{
  font-weight:950;
  font-size:.82rem;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.user-left small{
  color: var(--muted);
  font-size:.75rem;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.user-check{ width:18px; height:18px; }

.selected-users{ display:flex; flex-wrap:wrap; gap:6px; }
.user-chip{
  display:inline-flex;
  align-items:center;
  gap:6px;
  border-radius:999px;
  padding:6px 10px;
  border:1px solid rgba(226,232,240,.95);
  background: rgba(255,255,255,.9);
  font-size:.76rem;
  font-weight:950;
}
.user-chip button{
  border:0;
  background:transparent;
  font-weight:950;
  cursor:pointer;
  color: var(--muted);
}
.user-chip button:hover{ color: var(--danger); }

.pretty-modal .modal-dialog{ max-width: 920px; }
@media (max-width: 768px){ .pretty-modal .modal-dialog{ max-width: 96vw; } }
.pretty-modal .modal-content{
  border-radius: 18px;
  border: 1px solid rgba(226,232,240,.95);
  box-shadow: 0 30px 90px rgba(2,6,23,.22);
  overflow: hidden;
}
.pretty-modal .modal-header{
  border-bottom: 1px solid rgba(226,232,240,.9);
  background:
    radial-gradient(1000px 260px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
    radial-gradient(900px 240px at 95% 0%, rgba(124,58,237,.12), transparent 55%),
    #ffffff;
  padding: 14px 16px;
}
.pretty-modal .modal-body{
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, rgba(248,250,252,.75), #ffffff 40%);
}
.body-scroll{
  max-height: 520px;
  overflow-y: auto;
  padding-right: 4px;
}
.pretty-modal .modal-footer{
  border-top: 1px solid rgba(226,232,240,.9);
  padding: 12px 16px;
  background: #ffffff;
}
.header-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  flex-wrap:wrap;
}
.header-left{
  display:flex;
  align-items:center;
  gap:12px;
}
.icon-wrap{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(91,92,255,.10);
  border: 1px solid rgba(91,92,255,.18);
  display:grid;
  place-items:center;
}
.title-sub{
  margin-top:2px;
  font-size: .8rem;
  color: #64748b;
  font-weight: 500;
}
.form-grid{
  display:grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}
@media (max-width: 720px){ .form-grid{ grid-template-columns: 1fr; } }
.cardlet{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(226,232,240,.95);
  border-radius: 16px;
  padding: 10px 12px;
}
.cardlet-title{
  font-size: .78rem;
  color:#64748b;
  font-weight: 600;
  display:flex;
  align-items:center;
  gap:8px;
  margin-bottom: 8px;
}
.req{ color:#ef4444; font-weight:700; }

.form-control, .form-select{
  border-radius: 4px !important;
  border-color: rgba(226,232,240,.95) !important;
  padding-top: .55rem !important;
  padding-bottom: .55rem !important;
}
.form-control:focus, .form-select:focus{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}
.actions{
  display:flex;
  justify-content:flex-end;
  gap:10px;
  flex-wrap:wrap;
}
.btn-soft2{
  border-radius: 999px !important;
  border: 1px solid rgba(226,232,240,.95) !important;
  background: #fff !important;
}
.btn-primary{
  border-radius: 999px !important;
}

.search-select{
  position: relative;
}
.search-select .dropdown-card{
  position:absolute;
  top: calc(100% + 6px);
  left:0;
  right:0;
  z-index: 50;
  background:#fff;
  border:1px solid rgba(226,232,240,.95);
  border-radius:16px;
  box-shadow: 0 18px 60px rgba(2,6,23,.15);
  overflow:hidden;
}
.search-select .dropdown-head{
  padding:10px;
  border-bottom:1px solid rgba(226,232,240,.85);
  background: rgba(148,163,184,.06);
}
.search-select .dropdown-body{
  max-height: 260px;
  overflow:auto;
}
.search-select .rowx{
  padding:10px 10px;
  display:flex;
  justify-content:space-between;
  gap:10px;
  cursor:pointer;
}
.search-select .rowx:hover{
  background: rgba(148,163,184,.08);
}
.search-select .rowx b{
  font-size:.82rem;
  font-weight:950;
}
.search-select .rowx small{
  color: var(--muted);
  font-weight:700;
}
.note-box{
  border:1px solid rgba(226,232,240,.95);
  background: rgba(148,163,184,.05);
  border-radius: 16px;
  padding: 10px;
}
.note-item{
  border:1px solid rgba(226,232,240,.95);
  background: rgba(255,255,255,.9);
  border-radius: 14px;
  padding: 10px;
}
`;

const normalizeType = (t) => (t || "reuniao").toLowerCase();
const isTrainingOrPresentation = (type) =>
  ["apresentacao", "apresentação", "formacao", "formação"].includes(normalizeType(type));

const toNumArray = (raw) => {
  if (Array.isArray(raw)) return raw.map((x) => Number(x)).filter((n) => Number.isFinite(n));
  if (typeof raw === "string" && raw.trim()) {
    try {
      const j = JSON.parse(raw);
      if (Array.isArray(j)) return j.map((x) => Number(x)).filter((n) => Number.isFinite(n));
    } catch {}
    return raw
      .split(",")
      .map((x) => Number(String(x).trim()))
      .filter((n) => Number.isFinite(n));
  }
  return [];
};

const MeetingsAgendaTable = () => {
  const [meetings, setMeetings] = useState([]);
  const [users, setUsers] = useState([]);
  const [contacts, setContacts] = useState([]);

  const [search, setSearch] = useState("");
  const [view, setView] = useState("month");
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const [currentMonth, setCurrentMonth] = useState(moment().startOf("month"));

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    meeting_title: "",
    meeting_description: "",
    meeting_date: "",
    meeting_time: "",
    meeting_status: "agendado",
    meeting_type: "reuniao",
    meeting_location: "",
    meeting_contact_id: null,
    meeting_user_ids: [],
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [meetingToDelete, setMeetingToDelete] = useState(null);

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailsMeeting, setDetailsMeeting] = useState(null);

  const [showDayModal, setShowDayModal] = useState(false);
  const [dayModalDate, setDayModalDate] = useState(null);

  const [contactPickerOpen, setContactPickerOpen] = useState(false);
  const [contactSearch, setContactSearch] = useState("");

  const [showActivitiesModal, setShowActivitiesModal] = useState(false);
  const [activitiesUserId, setActivitiesUserId] = useState("");
  const [activitiesFrom, setActivitiesFrom] = useState("");
  const [activitiesTo, setActivitiesTo] = useState("");
  const [activitiesData, setActivitiesData] = useState([]);
  const [activitiesLoading, setActivitiesLoading] = useState(false);

  const [notes, setNotes] = useState([]);
  const [noteText, setNoteText] = useState("");
  const [notesLoading, setNotesLoading] = useState(false);

  const loadMeetings = async () => {
    try {
      const res = await axios.get(Hoot() + "agenda/list", { withCredentials: true });
      if (res.data?.success) setMeetings(res.data.data || []);
      else setMeetings(res.data?.data || res.data || []);
    } catch {
      toast.error("Erro ao carregar eventos.");
    }
  };

  const loadUsers = async () => {
    try {
      const res = await axios.get(Hoot() + "all-managers", { withCredentials: true });
      const payload = res.data || [];
      setUsers(Array.isArray(payload) ? payload : []);
    } catch {}
  };

  const loadContacts = async () => {
    try {
      const res = await axios.get(Hoot() + "contacts/list", { withCredentials: true });
      const payload = res.data?.data || res.data || [];
      setContacts(Array.isArray(payload) ? payload : []);
    } catch {}
  };

  useEffect(() => {
    loadMeetings();
    loadUsers();
    loadContacts();
  }, []);

  const usersById = useMemo(() => {
    const m = new Map();
    (users || []).forEach((u) => {
      const id = Number(u.ed_manager_account_id);
      if (!Number.isFinite(id)) return;
      m.set(id, {
        id,
        name: u.ed_manager_account_name || `User #${id}`,
        email: u.ed_manager_account_email || "",
        role: u.ed_manager_account_role || "",
      });
    });
    return m;
  }, [users]);

  const contactsById = useMemo(() => {
    const m = new Map();
    (contacts || []).forEach((c) => {
      const id = Number(c.ed_contact_id);
      if (!Number.isFinite(id)) return;
      m.set(id, c);
    });
    return m;
  }, [contacts]);

  const normalizedMeetings = useMemo(() => {
    return (meetings || []).map((m) => {
      const meeting_id = m.meeting_id ?? m.id;
      const meeting_user_ids = toNumArray(m.meeting_user_ids ?? m.meeting_users ?? m.users ?? []);
      const meeting_contact_id = m.meeting_contact_id ?? m.meeting_contact ?? null;

      return {
        ...m,
        meeting_id,
        meeting_title: m.meeting_title ?? m.title ?? "",
        meeting_description: m.meeting_description ?? m.description ?? "",
        meeting_date: m.meeting_date ?? m.date ?? "",
        meeting_time: m.meeting_time ?? m.time ?? "",
        meeting_status: (m.meeting_status ?? m.status ?? "agendado").toLowerCase(),
        meeting_type: m.meeting_type ?? m.type ?? "reuniao",
        meeting_location: m.meeting_location ?? m.location ?? "",
        meeting_contact_id: meeting_contact_id ? Number(meeting_contact_id) : null,
        contact_name: m.contact_name ?? "",
        contact_status: m.contact_status ?? "",
        meeting_user_ids,
      };
    });
  }, [meetings]);

  const filteredMeetings = useMemo(() => {
    const q = (search || "").toLowerCase();
    return normalizedMeetings
      .filter((m) => (m.meeting_title || "").toLowerCase().includes(q))
      .sort((a, b) =>
        moment(a.meeting_date + " " + (a.meeting_time || "00:00")).diff(
          moment(b.meeting_date + " " + (b.meeting_time || "00:00"))
        )
      );
  }, [normalizedMeetings, search]);

  const eventsByDay = useMemo(() => {
    const map = new Map();
    filteredMeetings.forEach((m) => {
      const k = m.meeting_date;
      if (!map.has(k)) map.set(k, []);
      map.get(k).push(m);
    });
    for (const [k, arr] of map.entries()) {
      arr.sort((a, b) => (a.meeting_time || "").localeCompare(b.meeting_time || ""));
      map.set(k, arr);
    }
    return map;
  }, [filteredMeetings]);

  const selectedDayEvents = useMemo(() => {
    const day = selectedDate;
    return (eventsByDay.get(day) || [])
      .slice()
      .sort((a, b) => (a.meeting_time || "").localeCompare(b.meeting_time || ""));
  }, [eventsByDay, selectedDate]);

  const monthStart = useMemo(() => currentMonth.clone().startOf("month"), [currentMonth]);
  const monthEnd = useMemo(() => currentMonth.clone().endOf("month"), [currentMonth]);
  const gridStart = useMemo(() => monthStart.clone().startOf("isoWeek"), [monthStart]);
  const gridEnd = useMemo(() => monthEnd.clone().endOf("isoWeek"), [monthEnd]);

  const monthDays = useMemo(() => {
    const days = [];
    const cursor = gridStart.clone();
    while (cursor.isSameOrBefore(gridEnd, "day")) {
      days.push(cursor.clone());
      cursor.add(1, "day");
    }
    return days;
  }, [gridStart, gridEnd]);

  const pageCount = useMemo(() => {
    if (!filteredMeetings.length) return 1;
    return Math.ceil(filteredMeetings.length / itemsPerPage);
  }, [filteredMeetings.length]);

  const paginatedMeetings = useMemo(() => {
    return filteredMeetings.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  }, [filteredMeetings, currentPage]);

  useEffect(() => setCurrentPage(1), [search]);

  const statusDotClass = (status) => {
    switch ((status || "agendado").toLowerCase()) {
      case "realizado":
        return "dot-realizado";
      case "adiado":
        return "dot-adiado";
      case "cancelado":
        return "dot-cancelado";
      default:
        return "dot-agendado";
    }
  };

  const statusPillClass = (status) => {
    switch ((status || "agendado").toLowerCase()) {
      case "realizado":
        return "status-pill st-realizado";
      case "adiado":
        return "status-pill st-adiado";
      case "cancelado":
        return "status-pill st-cancelado";
      default:
        return "status-pill st-agendado";
    }
  };

  const getStatusBgColor = (status) => {
    switch ((status || "agendado").toLowerCase()) {
      case "realizado":
        return "#16a34a";
      case "adiado":
        return "#f59e0b";
      case "cancelado":
        return "#ef4444";
      default:
        return "#3b82f6";
    }
  };

  const handleStatusChange = async (id, value) => {
    const prev = meetings;
    setMeetings((old) => (old || []).map((m) => ((m.meeting_id ?? m.id) === id ? { ...m, meeting_status: value } : m)));
    try {
      await axios.put(Hoot() + `agenda/updatestatus/${id}`, { meeting_status: value }, { withCredentials: true });
      toast.success("Estado atualizado.");
      loadMeetings();
    } catch {
      setMeetings(prev);
      toast.error("Erro ao atualizar estado.");
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const toggleUserId = (userId) => {
    const id = Number(userId);
    if (!Number.isFinite(id)) return;
    setForm((f) => {
      const exists = (f.meeting_user_ids || []).includes(id);
      const next = exists ? (f.meeting_user_ids || []).filter((x) => x !== id) : [...(f.meeting_user_ids || []), id];
      return { ...f, meeting_user_ids: next };
    });
  };

  const removeUserChip = (userId) => {
    const id = Number(userId);
    setForm((f) => ({ ...f, meeting_user_ids: (f.meeting_user_ids || []).filter((x) => x !== id) }));
  };

  const typeLabel = (t) => {
    const x = normalizeType(t);
    if (x === "apresentacao" || x === "apresentação") return "Apresentação";
    if (x === "formacao" || x === "formação") return "Formação";
    return "Reunião";
  };

  const openModal = (meeting = null, datePreselect = null) => {
    if (meeting) {
      setForm({
        meeting_title: meeting.meeting_title || "",
        meeting_description: meeting.meeting_description || "",
        meeting_date: moment(meeting.meeting_date).format("YYYY-MM-DD"),
        meeting_time: (meeting.meeting_time || "").slice(0, 5),
        meeting_status: meeting.meeting_status || "agendado",
        meeting_type: meeting.meeting_type || "reuniao",
        meeting_location: meeting.meeting_location || "",
        meeting_contact_id: meeting.meeting_contact_id ? Number(meeting.meeting_contact_id) : null,
        meeting_user_ids: toNumArray(meeting.meeting_user_ids || []),
      });
      setEditId(meeting.meeting_id);
    } else {
      const d = datePreselect || selectedDate || moment().format("YYYY-MM-DD");
      setForm({
        meeting_title: "",
        meeting_description: "",
        meeting_date: d,
        meeting_time: "",
        meeting_status: "agendado",
        meeting_type: "reuniao",
        meeting_location: "",
        meeting_contact_id: null,
        meeting_user_ids: [],
      });
      setEditId(null);
    }
    setContactPickerOpen(false);
    setContactSearch("");
    setShowModal(true);
  };

  const saveMeeting = async () => {
    try {
      if (!form.meeting_title || !form.meeting_date || !form.meeting_time) {
        toast.warning("Preencha: título, data e hora.");
        return;
      }
      if (isTrainingOrPresentation(form.meeting_type) && !(form.meeting_user_ids || []).length) {
        toast.warning("Para Apresentação/Formação, selecione os utilizadores participantes.");
        return;
      }

      const payload = {
        meeting_title: form.meeting_title,
        meeting_description: form.meeting_description,
        meeting_date: form.meeting_date,
        meeting_time: form.meeting_time,
        meeting_status: form.meeting_status,
        meeting_type: form.meeting_type,
        meeting_location: form.meeting_location,
        meeting_contact_id: form.meeting_contact_id,
        meeting_user_ids: form.meeting_user_ids,
      };

      if (editId) {
        await axios.put(Hoot() + `agenda/update/${editId}`, payload, { withCredentials: true });
        toast.success("Evento atualizado.");
      } else {
        await axios.post(Hoot() + "agenda/create", payload, { withCredentials: true });
        toast.success("Evento criado.");
      }

      setShowModal(false);
      loadMeetings();
    } catch {
      toast.error("Erro ao guardar evento.");
    }
  };

  const confirmDeleteMeeting = (meeting) => {
    setMeetingToDelete(meeting);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirmed = async () => {
    if (!meetingToDelete) return;
    try {
      await axios.delete(Hoot() + `agenda/delete/${meetingToDelete.meeting_id}`, { withCredentials: true });
      toast.success("Evento removido.");
      loadMeetings();
    } catch {
      toast.error("Erro ao remover evento.");
    } finally {
      setShowDeleteModal(false);
      setMeetingToDelete(null);
    }
  };

  const loadNotes = async (meetingId) => {
    setNotesLoading(true);
    try {
      const res = await axios.get(Hoot() + `agenda/${meetingId}/notes`, { withCredentials: true });
      setNotes(res.data?.data || []);
    } catch {
      setNotes([]);
    } finally {
      setNotesLoading(false);
    }
  };

  const addNote = async () => {
    if (!detailsMeeting?.meeting_id) return;
    const text = String(noteText || "").trim();
    if (!text) return toast.warning("Escreva uma nota.");
    try {
      await axios.post(Hoot() + `agenda/${detailsMeeting.meeting_id}/notes`, { text }, { withCredentials: true });
      setNoteText("");
      toast.success("Nota adicionada.");
      loadNotes(detailsMeeting.meeting_id);
    } catch {
      toast.error("Erro ao adicionar nota.");
    }
  };

  const deleteNote = async (noteId) => {
    if (!noteId) return;
    try {
      await axios.delete(Hoot() + `agenda/notes/${noteId}`, { withCredentials: true });
      toast.success("Nota removida.");
      if (detailsMeeting?.meeting_id) loadNotes(detailsMeeting.meeting_id);
    } catch {
      toast.error("Erro ao remover nota.");
    }
  };

  const openDetails = async (meeting) => {
    setDetailsMeeting(meeting);
    setShowDetailsModal(true);
    setNoteText("");
    if (meeting?.meeting_id) loadNotes(meeting.meeting_id);
  };

  const goPrevMonth = () => setCurrentMonth((m) => m.clone().subtract(1, "month"));
  const goNextMonth = () => setCurrentMonth((m) => m.clone().add(1, "month"));
  const goToday = () => {
    const today = moment();
    setCurrentMonth(today.clone().startOf("month"));
    setSelectedDate(today.format("YYYY-MM-DD"));
  };

  const handleDayClick = (dayMoment) => {
    const d = dayMoment.format("YYYY-MM-DD");
    setSelectedDate(d);
    openModal(null, d);
  };

  const openDayModal = (dayStr) => {
    setDayModalDate(dayStr);
    setShowDayModal(true);
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxButtons = 7;

    if (pageCount <= maxButtons) {
      for (let i = 1; i <= pageCount; i++) pages.push(i);
    } else {
      pages.push(1);
      let start = Math.max(2, currentPage - 1);
      let end = Math.min(pageCount - 1, currentPage + 1);
      if (start > 2) pages.push("...");
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < pageCount - 1) pages.push("...");
      pages.push(pageCount);
    }

    return pages.map((p, idx) =>
      p === "..." ? (
        <li key={`ellipsis-${idx}`} className="page-item disabled">
          <span className="page-link">…</span>
        </li>
      ) : (
        <li key={p} className={`page-item ${currentPage === p ? "active" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage(p)}>
            {p}
          </button>
        </li>
      )
    );
  };

  const selectedContact = useMemo(() => {
    const id = form.meeting_contact_id ? Number(form.meeting_contact_id) : null;
    if (!id) return null;
    return contactsById.get(id) || null;
  }, [form.meeting_contact_id, contactsById]);

  const filteredContacts = useMemo(() => {
    const q = String(contactSearch || "").toLowerCase().trim();
    const list = contacts || [];
    if (!q) return list.slice(0, 60);
    return list
      .filter((c) => {
        const n = String(c.ed_contact_name || "").toLowerCase();
        const p = String(c.ed_contact_phone || "").toLowerCase();
        const e = String(c.ed_contact_email || "").toLowerCase();
        const a = String(c.ed_contact_address || "").toLowerCase();
        return n.includes(q) || p.includes(q) || e.includes(q) || a.includes(q);
      })
      .slice(0, 80);
  }, [contacts, contactSearch]);

  const updateContactStatus = async (contactId, newStatus) => {
    try {
      await axios.post(
        Hoot() + "contacts/update-status",
        { contact_id: contactId, contact_status: newStatus },
        { withCredentials: true }
      );
      toast.success("Estado do contacto actualizado.");
      loadContacts();
      if (detailsMeeting?.meeting_id) {
        const updated = { ...detailsMeeting, contact_status: newStatus };
        setDetailsMeeting(updated);
      }
    } catch {
      toast.error("Erro ao atualizar estado do contacto.");
    }
  };

  const openActivitiesModal = () => {
    const now = moment();
    setActivitiesTo(now.format("YYYY-MM-DD"));
    setActivitiesFrom(now.clone().subtract(30, "days").format("YYYY-MM-DD"));
    setActivitiesUserId("");
    setActivitiesData([]);
    setShowActivitiesModal(true);
  };

  const fetchActivities = async () => {
    const uid = Number(activitiesUserId);
    if (!Number.isFinite(uid) || uid <= 0) return toast.warning("Selecione um utilizador.");
    const from = activitiesFrom || moment().subtract(30, "days").format("YYYY-MM-DD");
    const to = activitiesTo || moment().format("YYYY-MM-DD");

    setActivitiesLoading(true);
    try {
      const res = await axios.get(Hoot() + `users/${uid}/activities`, {
        withCredentials: true,
        params: { from, to },
      });
      setActivitiesData(res.data?.data || []);
    } catch {
      toast.error("Erro ao carregar actividades.");
      setActivitiesData([]);
    } finally {
      setActivitiesLoading(false);
    }
  };

  return (
    <>
      <style>{schedulerStyles}</style>

      <div className="scheduler-shell">
        <div className="scheduler-card">
          <div className="scheduler-header">
            <div className="scheduler-title">
              <FaCalendarAlt />
              <span>Agenda</span>
              <span className="scheduler-chip">{filteredMeetings.length} evento(s)</span>
              <span className="badge-mini">Dia: {moment(selectedDate).format("DD/MM/YYYY")}</span>
            </div>

            <div className="top-actions">
              <button className="btn-soft btn-primary-soft" onClick={() => openModal(null, selectedDate)}>
                <FaPlus /> Novo evento
              </button>
              <button className="btn-soft" onClick={openActivitiesModal}>
                <FaFilter /> Atividades
              </button>
              <button className="btn-soft" onClick={loadMeetings}>
                <i className="bi bi-arrow-clockwise" /> Atualizar
              </button>
            </div>
          </div>

          <div className="scheduler-toolbar">
            <div className="toolbar-row">
              <div className="toolbar-left">
                <div className="input-pill">
                  <i className="bi bi-search" />
                  <input
                    type="search"
                    placeholder="Pesquisar por título…"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <div className="view-seg">
                  <button
                    type="button"
                    className={view === "month" ? "active" : ""}
                    onClick={() => setView("month")}
                    title="Calendário mensal"
                  >
                    <FaThLarge /> Mês
                  </button>
                  <button
                    type="button"
                    className={view === "list" ? "active" : ""}
                    onClick={() => setView("list")}
                    title="Lista"
                  >
                    <FaListUl /> Lista
                  </button>
                </div>
              </div>

              <div className="toolbar-right">
                <small style={{ color: "var(--muted)", fontWeight: 950 }}>
                  Página {currentPage} de {pageCount}
                </small>
              </div>
            </div>
          </div>

          <div className="scheduler-main">
            <div>
              {view === "month" ? (
                <div className="month-card">
                  <div className="month-head">
                    <div className="month-title">
                      <span>{currentMonth.format("MMMM")}</span>
                      <span style={{ color: "var(--muted)", fontWeight: 950 }}>{currentMonth.format("YYYY")}</span>
                    </div>
                    <div className="month-nav">
                      <button className="today-btn" type="button" onClick={goToday}>
                        Hoje
                      </button>
                      <button className="nav-btn" type="button" onClick={goPrevMonth} title="Mês anterior">
                        <FaChevronLeft />
                      </button>
                      <button className="nav-btn" type="button" onClick={goNextMonth} title="Mês seguinte">
                        <FaChevronRight />
                      </button>
                    </div>
                  </div>

                  <div className="month-grid">
                    {["seg", "ter", "qua", "qui", "sex", "sáb", "dom"].map((d) => (
                      <div key={d} className="month-dow">
                        {d}
                      </div>
                    ))}

                    {monthDays.map((d) => {
                      const dayStr = d.format("YYYY-MM-DD");
                      const isOtherMonth = !d.isSame(currentMonth, "month");
                      const isSelected = dayStr === selectedDate;
                      const isToday = d.isSame(moment(), "day");

                      const dayEvents = eventsByDay.get(dayStr) || [];
                      const total = dayEvents.length;
                      const dots = dayEvents.slice(0, 4);

                      return (
                        <div
                          key={dayStr}
                          className={"month-cell" + (isOtherMonth ? " other-month" : "") + (isSelected ? " selected" : "")}
                          onClick={() => handleDayClick(d)}
                          title="Clique para criar evento neste dia"
                        >
                          <div className="day-number">
                            <span>{d.date()}</span>
                            <span>{isToday ? <span className="badge-today">Hoje</span> : null}</span>
                          </div>

                          {total > 0 ? (
                            <div className="dots-row" title={`${total} evento(s)`}>
                              {dots.map((ev) => (
                                <span key={ev.meeting_id} className={"dot " + statusDotClass(ev.meeting_status)} />
                              ))}
                              {total > dots.length ? <span className="more-mini">+{total - dots.length}</span> : null}
                            </div>
                          ) : (
                            <div className="small text-muted" style={{ fontSize: ".74rem", marginTop: 8 }}>
                              Clique para adicionar
                            </div>
                          )}

                          {dayEvents.slice(0, 2).map((ev) => (
                            <div
                              key={ev.meeting_id}
                              className="event-line"
                              onClick={(e) => {
                                e.stopPropagation();
                                openDetails(ev);
                              }}
                              role="button"
                              title="Ver detalhes"
                            >
                              <span className={"event-dot " + statusDotClass(ev.meeting_status)} />
                              <time>{(ev.meeting_time || "—").slice(0, 5)}</time>
                              <b>{ev.meeting_title || "Sem título"}</b>
                            </div>
                          ))}

                          {total > 2 ? (
                            <div
                              className="more-link"
                              role="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                openDayModal(dayStr);
                              }}
                              title="Ver todos os eventos do dia"
                            >
                              +{total - 2} mais
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="panel-card">
                  <div className="panel-head">
                    <div>
                      <p className="panel-title">Lista de eventos</p>
                      <div className="panel-sub">
                        <span className="meta-chip">
                          <FaListUl /> {filteredMeetings.length} registos
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover align-middle table-sm mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Título</th>
                            <th>Data</th>
                            <th>Hora</th>
                            <th>Tipo</th>
                            <th>Escola</th>
                            <th>Estado</th>
                            <th className="text-end">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedMeetings.map((item) => {
                            const c = item.meeting_contact_id ? contactsById.get(Number(item.meeting_contact_id)) : null;
                            return (
                              <tr key={item.meeting_id}>
                                <td className="fw-semibold">{item.meeting_title}</td>
                                <td>{moment(item.meeting_date).format("DD/MM/YYYY")}</td>
                                <td>{(item.meeting_time || "--:--").slice(0, 5)}</td>
                                <td>
                                  <span className="badge-mini">{typeLabel(item.meeting_type)}</span>
                                </td>
                                <td>
                                  <span className="badge-mini">
                                    <FaUniversity style={{ marginRight: 6 }} />
                                    {item.contact_name || c?.ed_contact_name || "—"}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <span className={statusPillClass(item.meeting_status)}>{item.meeting_status || "agendado"}</span>
                                    <select
                                      className="form-select form-select-sm"
                                      style={{
                                        maxWidth: 150,
                                        borderRadius: 999,
                                        fontWeight: 950,
                                        color: "#fff",
                                        backgroundColor: getStatusBgColor(item.meeting_status),
                                        border: "0",
                                      }}
                                      value={item.meeting_status || "agendado"}
                                      onChange={(e) => handleStatusChange(item.meeting_id, e.target.value)}
                                    >
                                      <option value="agendado">Agendado</option>
                                      <option value="realizado">Realizado</option>
                                      <option value="adiado">Adiado</option>
                                      <option value="cancelado">Cancelado</option>
                                    </select>
                                  </div>
                                </td>
                                <td className="text-end">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="icon-btn" title="Detalhes" onClick={() => openDetails(item)}>
                                      <FaEye />
                                    </button>
                                    <button className="icon-btn" title="Editar" onClick={() => openModal(item)}>
                                      <FaEdit />
                                    </button>
                                    <button className="icon-btn" title="Remover" onClick={() => confirmDeleteMeeting(item)}>
                                      <FaTrash />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}

                          {paginatedMeetings.length === 0 ? (
                            <tr>
                              <td colSpan={7}>
                                <span className="text-muted small">Sem registos para os filtros atuais.</span>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>

                    <div className="pagination-wrap">
                      <nav>
                        <ul className="pagination pagination-sm mb-0">
                          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}>
                              «
                            </button>
                          </li>
                          {renderPageNumbers()}
                          <li className={`page-item ${currentPage === pageCount ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => setCurrentPage((p) => Math.min(pageCount, p + 1))}>
                              »
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="panel-card">
              <div className="panel-head">
                <div>
                  <p className="panel-title">Agenda do dia</p>
                  <div className="panel-sub">
                    <span className="meta-chip">
                      <FaRegClock /> {moment(selectedDate).format("dddd, DD [de] MMMM")}
                    </span>
                    <span className="meta-chip">
                      <FaCalendarAlt /> {selectedDayEvents.length} evento(s)
                    </span>
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <button className="btn-soft btn-primary-soft" type="button" onClick={() => openModal(null, selectedDate)}>
                    <FaPlus /> Novo
                  </button>
                </div>
              </div>

              <div className="panel-body">
                <div className="day-agenda">
                  {selectedDayEvents.map((ev) => {
                    const c = ev.meeting_contact_id ? contactsById.get(Number(ev.meeting_contact_id)) : null;
                    return (
                      <div key={ev.meeting_id} className="agenda-item">
                        <div className="agenda-top">
                          <div style={{ minWidth: 0 }}>
                            <p className="agenda-title">{ev.meeting_title}</p>
                            <div className="agenda-meta">
                              <span className="meta-chip">
                                <FaRegClock /> {(ev.meeting_time || "--:--").slice(0, 5)}
                              </span>
                              <span className="meta-chip">
                                {isTrainingOrPresentation(ev.meeting_type) ? <FaChalkboardTeacher /> : <FaCalendarAlt />}
                                {typeLabel(ev.meeting_type)}
                              </span>

                              <span className="meta-chip" title="Contacto/Escola">
                                <FaUniversity /> {ev.contact_name || c?.ed_contact_name || "—"}
                              </span>

                              {ev.meeting_location ? (
                                <span className="meta-chip">
                                  <FaMapMarkerAlt /> {ev.meeting_location}
                                </span>
                              ) : null}

                              <span className={statusPillClass(ev.meeting_status)}>{ev.meeting_status || "agendado"}</span>
                            </div>

                            {isTrainingOrPresentation(ev.meeting_type) ? (
                              <div style={{ marginTop: 10 }}>
                                <div style={{ fontWeight: 950, fontSize: ".78rem", color: "var(--muted)", marginBottom: 6 }}>
                                  <FaUsers style={{ marginRight: 6 }} />
                                  Participantes
                                </div>
                                <div className="selected-users">
                                  {(ev.meeting_user_ids || []).length ? (
                                    (ev.meeting_user_ids || []).map((uid) => {
                                      const u = usersById.get(Number(uid));
                                      return (
                                        <span key={uid} className="user-chip">
                                          {u?.name || `User #${uid}`}
                                        </span>
                                      );
                                    })
                                  ) : (
                                    <span className="text-muted small">Sem participantes definidos.</span>
                                  )}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>

                        <div className="agenda-actions">
                          <button className="icon-btn" title="Detalhes" onClick={() => openDetails(ev)}>
                            <FaEye />
                          </button>
                          <button className="icon-btn" title="Editar" onClick={() => openModal(ev)}>
                            <FaEdit />
                          </button>
                          <button className="icon-btn" title="Remover" onClick={() => confirmDeleteMeeting(ev)}>
                            <FaTrash />
                          </button>
                        </div>
                      </div>
                    );
                  })}

                  {selectedDayEvents.length === 0 ? (
                    <span className="text-muted small">
                      Sem eventos para este dia. Clique em <b>Novo</b> para criar.
                    </span>
                  ) : null}
                </div>

                <div className="section-divider" />

                <div className="table-title">
                  <span>Todos os eventos (lista rápida)</span>
                  <span className="badge-mini">{filteredMeetings.length} total</span>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover align-middle table-sm mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Título</th>
                        <th>Data</th>
                        <th>Hora</th>
                        <th>Estado</th>
                        <th className="text-end">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedMeetings.map((item) => (
                        <tr key={item.meeting_id}>
                          <td className="fw-semibold">{item.meeting_title}</td>
                          <td>{moment(item.meeting_date).format("DD/MM/YYYY")}</td>
                          <td>{(item.meeting_time || "--:--").slice(0, 5)}</td>
                          <td>
                            <span className={statusPillClass(item.meeting_status)}>{item.meeting_status || "agendado"}</span>
                          </td>
                          <td className="text-end">
                            <div className="d-flex justify-content-end gap-2">
                              <button className="icon-btn" title="Detalhes" onClick={() => openDetails(item)}>
                                <FaEye />
                              </button>
                              <button className="icon-btn" title="Editar" onClick={() => openModal(item)}>
                                <FaEdit />
                              </button>
                              <button className="icon-btn" title="Remover" onClick={() => confirmDeleteMeeting(item)}>
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}

                      {paginatedMeetings.length === 0 ? (
                        <tr>
                          <td colSpan={5}>
                            <span className="text-muted small">Sem registos para os filtros atuais.</span>
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-wrap">
                  <nav>
                    <ul className="pagination pagination-sm mb-0">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}>
                          «
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li className={`page-item ${currentPage === pageCount ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setCurrentPage((p) => Math.min(pageCount, p + 1))}>
                          »
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={() => setShowModal(false)} centered backdrop="static" keyboard className="pretty-modal">
          <Modal.Header closeButton>
            <div className="header-row" style={{ width: "100%" }}>
              <div className="header-left">
                <div className="icon-wrap">
                  <FaCalendarAlt style={{ color: "#5b5cff", fontSize: 18 }} />
                </div>
                <div>
                  <div style={{ fontWeight: 650 }}>{editId ? "Editar evento" : "Novo evento"}</div>
                  <div className="title-sub">
                    Data selecionada: <b>{form.meeting_date ? moment(form.meeting_date).format("DD/MM/YYYY") : "—"}</b>
                  </div>
                </div>
              </div>
              <span className="badge-mini">
                {typeLabel(form.meeting_type)} • {form.meeting_status || "agendado"}
              </span>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="body-scroll">
              <div className="form-grid">
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <FaCalendarAlt /> Identificação
                  </div>

                  <div className="form-grid">
                    <div>
                      <label className="form-label small fw-semibold">
                        Título <span className="req">*</span>
                      </label>
                      <input
                        type="text"
                        name="meeting_title"
                        className="form-control"
                        value={form.meeting_title}
                        onChange={handleInput}
                        placeholder="Ex: Reunião com escola / Apresentação / Formação"
                      />
                    </div>

                    <div>
                      <label className="form-label small fw-semibold">Tipo</label>
                      <select
                        name="meeting_type"
                        className="form-select"
                        value={form.meeting_type}
                        onChange={(e) => {
                          const v = e.target.value;
                          setForm((f) => ({
                            ...f,
                            meeting_type: v,
                            meeting_user_ids: isTrainingOrPresentation(v) ? f.meeting_user_ids : [],
                          }));
                        }}
                      >
                        <option value="reuniao">Reunião</option>
                        <option value="apresentacao">Apresentação</option>
                        <option value="formacao">Formação</option>
                      </select>
                      <div className="text-muted small mt-1">
                        Para <b>Apresentação</b>/<b>Formação</b>, escolha participantes.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <FaUniversity /> Escola / Contacto
                  </div>

                  <div className="search-select">
                    <label className="form-label small fw-semibold">Selecionar escola (pesquisa)</label>
                    <div className="d-flex gap-2">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          selectedContact
                            ? selectedContact.ed_contact_name
                            : form.meeting_contact_id
                            ? `ID: ${form.meeting_contact_id}`
                            : ""
                        }
                        placeholder="Clique para selecionar…"
                        onFocus={() => setContactPickerOpen(true)}
                        readOnly
                      />
                      <button
                        className="btn-soft btn-primary-soft"
                        type="button"
                        onClick={() => setContactPickerOpen((s) => !s)}
                      >
                        <FaUniversity /> Escolher
                      </button>
                    </div>

                    {selectedContact ? (
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        <span className="badge-mini">
                          {selectedContact.ed_contact_status ? `Estado: ${selectedContact.ed_contact_status}` : "Sem estado"}
                        </span>
                        <button
                          className="btn-soft"
                          type="button"
                          onClick={() => {
                            setForm((f) => ({ ...f, meeting_contact_id: null }));
                            setContactSearch("");
                            setContactPickerOpen(true);
                          }}
                        >
                          Limpar
                        </button>
                      </div>
                    ) : null}

                    {contactPickerOpen ? (
                      <div className="dropdown-card">
                        <div className="dropdown-head">
                          <div className="input-pill" style={{ width: "100%" }}>
                            <i className="bi bi-search" />
                            <input
                              type="search"
                              placeholder="Pesquisar escola/contacto…"
                              value={contactSearch}
                              onChange={(e) => setContactSearch(e.target.value)}
                              autoFocus
                            />
                          </div>
                        </div>

                        <div className="dropdown-body">
                          {filteredContacts.map((c) => (
                            <div
                              key={c.ed_contact_id}
                              className="rowx"
                              onClick={() => {
                                setForm((f) => ({ ...f, meeting_contact_id: Number(c.ed_contact_id) }));
                                setContactPickerOpen(false);
                              }}
                            >
                              <div style={{ minWidth: 0 }}>
                                <b title={c.ed_contact_name}>{c.ed_contact_name || "Sem nome"}</b>
                                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 4 }}>
                                  {c.ed_contact_status ? <small>Estado: {c.ed_contact_status}</small> : <small>Sem estado</small>}
                                  {c.ed_contact_phone ? <small>Tel: {c.ed_contact_phone}</small> : null}
                                </div>
                              </div>
                              <small style={{ fontWeight: 950 }}>#{c.ed_contact_id}</small>
                            </div>
                          ))}
                          {filteredContacts.length === 0 ? (
                            <div className="p-3 text-muted small">Sem resultados.</div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <FaRegClock /> Agenda
                  </div>

                  <div className="form-grid">
                    <div>
                      <label className="form-label small fw-semibold">
                        Data <span className="req">*</span>
                      </label>
                      <input type="date" name="meeting_date" className="form-control" value={form.meeting_date} onChange={handleInput} />
                    </div>

                    <div>
                      <label className="form-label small fw-semibold">
                        Hora <span className="req">*</span>
                      </label>
                      <input type="time" name="meeting_time" className="form-control" value={form.meeting_time} onChange={handleInput} />
                    </div>

                    <div>
                      <label className="form-label small fw-semibold">Estado</label>
                      <select name="meeting_status" className="form-select" value={form.meeting_status} onChange={handleInput}>
                        <option value="agendado">Agendado</option>
                        <option value="realizado">Realizado</option>
                        <option value="adiado">Adiado</option>
                        <option value="cancelado">Cancelado</option>
                      </select>
                    </div>

                    <div>
                      <label className="form-label small fw-semibold">Local (opcional)</label>
                      <input
                        type="text"
                        name="meeting_location"
                        className="form-control"
                        value={form.meeting_location}
                        onChange={handleInput}
                        placeholder="Ex: Escola X / Online / Maputo…"
                      />
                    </div>
                  </div>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <FaEdit /> Descrição / Notas
                  </div>
                  <textarea
                    name="meeting_description"
                    className="form-control"
                    rows={3}
                    value={form.meeting_description}
                    onChange={handleInput}
                    placeholder="Objectivo, pontos, próximos passos…"
                  />
                </div>

                {isTrainingOrPresentation(form.meeting_type) ? (
                  <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                    <div className="cardlet-title">
                      <FaUsers /> Participantes <span className="req">*</span>
                    </div>

                    {(form.meeting_user_ids || []).length ? (
                      <div className="selected-users mb-2">
                        {(form.meeting_user_ids || []).map((uid) => {
                          const u = usersById.get(Number(uid));
                          return (
                            <span key={uid} className="user-chip">
                              {u?.name || `User #${uid}`}
                              <button type="button" title="Remover" onClick={() => removeUserChip(uid)}>
                                ×
                              </button>
                            </span>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-muted small mb-2">Nenhum participante selecionado.</div>
                    )}

                    <div className="user-pick">
                      {(users || []).map((u) => {
                        const id = Number(u.ed_manager_account_id);
                        const name = u.ed_manager_account_name || `User #${id}`;
                        const email = u.ed_manager_account_email || "";
                        const checked = (form.meeting_user_ids || []).includes(id);

                        return (
                          <div key={id} className="user-row">
                            <div className="user-left">
                              <b title={name}>{name}</b>
                              <small title={email}>{email}</small>
                            </div>
                            <input className="user-check" type="checkbox" checked={checked} onChange={() => toggleUserId(id)} />
                          </div>
                        );
                      })}
                      {(users || []).length === 0 ? <span className="text-muted small">Sem utilizadores para listar.</span> : null}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="actions" style={{ width: "100%" }}>
              <Button variant="outline-secondary" className="btn-soft2" onClick={() => setShowModal(false)}>
                Cancelar
              </Button>
              <Button variant="primary" onClick={saveMeeting}>
                {editId ? "Guardar" : "Criar"}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered backdrop="static" keyboard className="pretty-modal">
          <Modal.Header closeButton>
            <div className="header-row" style={{ width: "100%" }}>
              <div className="header-left">
                <div className="icon-wrap">
                  <FaEye style={{ color: "#5b5cff", fontSize: 18 }} />
                </div>
                <div>
                  <div style={{ fontWeight: 650 }}>Detalhes do evento</div>
                  <div className="title-sub">
                    {detailsMeeting?.meeting_date ? moment(detailsMeeting.meeting_date).format("DD/MM/YYYY") : "—"}
                    {detailsMeeting?.meeting_time ? ` • ${(detailsMeeting.meeting_time || "").slice(0, 5)}` : ""}
                  </div>
                </div>
              </div>

              {detailsMeeting ? <span className={statusPillClass(detailsMeeting.meeting_status)}>{detailsMeeting.meeting_status || "agendado"}</span> : null}
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="body-scroll">
              {detailsMeeting ? (
                <div className="form-grid">
                  <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                    <div className="cardlet-title">
                      <FaCalendarAlt /> {typeLabel(detailsMeeting.meeting_type)}
                    </div>
                    <h5 style={{ fontWeight: 950, marginBottom: 8 }}>{detailsMeeting.meeting_title}</h5>

                    <div className="d-flex flex-wrap gap-2 mb-2">
                      <span className="badge-mini">
                        <FaRegClock style={{ marginRight: 6 }} />
                        {(detailsMeeting.meeting_time || "--:--").slice(0, 5)}
                      </span>
                      <span className="badge-mini">
                        <FaCalendarAlt style={{ marginRight: 6 }} />
                        {moment(detailsMeeting.meeting_date).format("DD/MM/YYYY")}
                      </span>
                      <span className="badge-mini">
                        {isTrainingOrPresentation(detailsMeeting.meeting_type) ? <FaChalkboardTeacher style={{ marginRight: 6 }} /> : <FaCalendarAlt style={{ marginRight: 6 }} />}
                        {typeLabel(detailsMeeting.meeting_type)}
                      </span>
                      {detailsMeeting.meeting_location ? (
                        <span className="badge-mini">
                          <FaMapMarkerAlt style={{ marginRight: 6 }} />
                          {detailsMeeting.meeting_location}
                        </span>
                      ) : null}
                    </div>

                    <div className="text-muted small" style={{ whiteSpace: "pre-wrap" }}>
                      {detailsMeeting.meeting_description || "Sem descrição."}
                    </div>
                  </div>

                  <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                    <div className="cardlet-title">
                      <FaUniversity /> Escola / Contacto
                    </div>

                    {(() => {
                      const cid = detailsMeeting.meeting_contact_id ? Number(detailsMeeting.meeting_contact_id) : null;
                      const c = cid ? contactsById.get(cid) : null;
                      const name = detailsMeeting.contact_name || c?.ed_contact_name || "—";
                      const status = detailsMeeting.contact_status || c?.ed_contact_status || "";

                      return (
                        <>
                          <div className="d-flex flex-wrap gap-2 mb-2">
                            <span className="badge-mini">
                              <FaUniversity style={{ marginRight: 6 }} />
                              {name}
                            </span>
                            <span className="badge-mini">{status ? `Estado: ${status}` : "Sem estado"}</span>
                          </div>

                          {cid ? (
                            <div className="d-flex flex-wrap gap-2 align-items-center">
                              <span className="text-muted small" style={{ fontWeight: 900 }}>
                                Atualizar estado do contacto:
                              </span>
                              <select
                                className="form-select form-select-sm"
                                style={{ maxWidth: 240, borderRadius: 999, fontWeight: 950 }}
                                value={status || ""}
                                onChange={(e) => updateContactStatus(cid, e.target.value)}
                              >
                                <option value="" disabled>
                                  Escolher…
                                </option>
                                <option value="parado">Parado</option>
                                <option value="contacto">Contactado</option>
                                <option value="em andamento">Em andamento / Apresentado</option>
                                <option value="em uso">Em uso</option>
                                <option value="rejeitado">Rejeitado</option>
                                <option value="não atende">Não atende</option>
                                <option value="interessado">Interessado</option>
                              </select>
                            </div>
                          ) : (
                            <span className="text-muted small">Sem contacto associado.</span>
                          )}
                        </>
                      );
                    })()}
                  </div>

                  {isTrainingOrPresentation(detailsMeeting.meeting_type) ? (
                    <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                      <div className="cardlet-title">
                        <FaUsers /> Participantes
                      </div>
                      <div className="selected-users">
                        {(detailsMeeting.meeting_user_ids || []).length ? (
                          (detailsMeeting.meeting_user_ids || []).map((uid) => {
                            const u = usersById.get(Number(uid));
                            return <span key={uid} className="user-chip">{u?.name || `User #${uid}`}</span>;
                          })
                        ) : (
                          <span className="text-muted small">Sem participantes definidos.</span>
                        )}
                      </div>
                    </div>
                  ) : null}

                  <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                    <div className="cardlet-title">
                      <FaRegStickyNote /> Notas
                    </div>

                    <div className="note-box">
                      <div className="d-flex gap-2">
                        <input
                          className="form-control"
                          value={noteText}
                          onChange={(e) => setNoteText(e.target.value)}
                          placeholder="Escreva uma nota…"
                        />
                        <button className="btn-soft btn-primary-soft" type="button" onClick={addNote}>
                          <FaPlus /> Adicionar
                        </button>
                      </div>

                      <div className="mt-3 d-flex flex-column gap-2">
                        {notesLoading ? (
                          <span className="text-muted small">A carregar notas…</span>
                        ) : (notes || []).length ? (
                          (notes || []).map((n) => (
                            <div key={n.mn_id} className="note-item">
                              <div className="d-flex justify-content-between gap-2 align-items-start">
                                <div style={{ minWidth: 0 }}>
                                  <div style={{ fontWeight: 950, fontSize: ".82rem" }}>{n.mn_created_by || "Sistema"}</div>
                                  <div className="text-muted small">
                                    {n.mn_created_at ? moment(n.mn_created_at).format("DD/MM/YYYY HH:mm") : ""}
                                  </div>
                                </div>
                                <button className="icon-btn" title="Remover nota" onClick={() => deleteNote(n.mn_id)}>
                                  <FaTrash />
                                </button>
                              </div>
                              <div className="mt-2" style={{ whiteSpace: "pre-wrap", fontSize: ".84rem" }}>
                                {n.mn_text}
                              </div>
                            </div>
                          ))
                        ) : (
                          <span className="text-muted small">Sem notas.</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <span className="text-muted">Sem dados.</span>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="actions" style={{ width: "100%" }}>
              {detailsMeeting ? (
                <>
                  <Button
                    variant="outline-secondary"
                    className="btn-soft2"
                    onClick={() => {
                      setShowDetailsModal(false);
                      openModal(detailsMeeting);
                    }}
                  >
                    <FaEdit style={{ marginRight: 6 }} />
                    Editar
                  </Button>
                  <Button
                    variant="outline-danger"
                    className="btn-soft2"
                    onClick={() => {
                      setShowDetailsModal(false);
                      confirmDeleteMeeting(detailsMeeting);
                    }}
                  >
                    <FaTrash style={{ marginRight: 6 }} />
                    Remover
                  </Button>
                </>
              ) : null}

              <Button variant="primary" onClick={() => setShowDetailsModal(false)}>
                Fechar
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={showDayModal} onHide={() => setShowDayModal(false)} centered backdrop="static" keyboard className="pretty-modal">
          <Modal.Header closeButton>
            <div className="header-row" style={{ width: "100%" }}>
              <div className="header-left">
                <div className="icon-wrap">
                  <FaThLarge style={{ color: "#5b5cff", fontSize: 18 }} />
                </div>
                <div>
                  <div style={{ fontWeight: 650 }}>Eventos do dia</div>
                  <div className="title-sub">{dayModalDate ? moment(dayModalDate).format("dddd, DD [de] MMMM") : "—"}</div>
                </div>
              </div>

              <Button
                variant="primary"
                className="rounded-pill"
                onClick={() => {
                  if (!dayModalDate) return;
                  setShowDayModal(false);
                  openModal(null, dayModalDate);
                }}
              >
                <FaPlus style={{ marginRight: 6 }} />
                Novo
              </Button>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="body-scroll">
              {dayModalDate ? (
                <div className="d-flex flex-column gap-2">
                  {(eventsByDay.get(dayModalDate) || []).map((ev) => (
                    <div
                      key={ev.meeting_id}
                      className="agenda-item"
                      role="button"
                      onClick={() => {
                        setShowDayModal(false);
                        setSelectedDate(dayModalDate);
                        openDetails(ev);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="agenda-top">
                        <div style={{ minWidth: 0 }}>
                          <p className="agenda-title">{ev.meeting_title}</p>
                          <div className="agenda-meta">
                            <span className="meta-chip">
                              <FaRegClock /> {(ev.meeting_time || "--:--").slice(0, 5)}
                            </span>
                            <span className="meta-chip">
                              {isTrainingOrPresentation(ev.meeting_type) ? <FaChalkboardTeacher /> : <FaCalendarAlt />}
                              {typeLabel(ev.meeting_type)}
                            </span>
                            <span className={statusPillClass(ev.meeting_status)}>{ev.meeting_status || "agendado"}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {(eventsByDay.get(dayModalDate) || []).length === 0 ? <span className="text-muted small">Sem eventos.</span> : null}
                </div>
              ) : (
                <span className="text-muted">Sem dados.</span>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="actions" style={{ width: "100%" }}>
              <Button variant="outline-secondary" className="btn-soft2" onClick={() => setShowDayModal(false)}>
                Fechar
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered backdrop="static" keyboard className="pretty-modal">
          <Modal.Header closeButton>
            <div className="header-row" style={{ width: "100%" }}>
              <div className="header-left">
                <div className="icon-wrap" style={{ background: "rgba(239,68,68,.10)", borderColor: "rgba(239,68,68,.18)" }}>
                  <FaTrash style={{ color: "#ef4444", fontSize: 18 }} />
                </div>
                <div>
                  <div style={{ fontWeight: 650 }}>Confirmar remoção</div>
                  <div className="title-sub">Esta ação não pode ser desfeita.</div>
                </div>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="body-scroll">
              <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                <div className="cardlet-title">
                  <FaTrash /> Evento
                </div>
                Tem a certeza que deseja remover o evento <strong>{meetingToDelete?.meeting_title}</strong>?
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="actions" style={{ width: "100%" }}>
              <Button variant="outline-secondary" className="btn-soft2" onClick={() => setShowDeleteModal(false)}>
                Cancelar
              </Button>
              <Button variant="danger" className="rounded-pill" onClick={handleDeleteConfirmed}>
                Remover
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={showActivitiesModal} onHide={() => setShowActivitiesModal(false)} centered backdrop="static" keyboard className="pretty-modal">
          <Modal.Header closeButton>
            <div className="header-row" style={{ width: "100%" }}>
              <div className="header-left">
                <div className="icon-wrap">
                  <FaFilter style={{ color: "#5b5cff", fontSize: 18 }} />
                </div>
                <div>
                  <div style={{ fontWeight: 650 }}>Atividades por utilizador</div>
                  <div className="title-sub">Filtra todas as reuniões onde o user participou (criou ou foi participante)</div>
                </div>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="body-scroll">
              <div className="form-grid">
                <div className="cardlet">
                  <div className="cardlet-title">
                    <FaUsers /> Utilizador
                  </div>
                  <select className="form-select" value={activitiesUserId} onChange={(e) => setActivitiesUserId(e.target.value)}>
                    <option value="">Selecionar…</option>
                    {(users || []).map((u) => (
                      <option key={u.ed_manager_account_id} value={u.ed_manager_account_id}>
                        {u.ed_manager_account_name || `User #${u.ed_manager_account_id}`}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">
                    <FaRegClock /> Intervalo
                  </div>
                  <div className="d-flex gap-2">
                    <input className="form-control" type="date" value={activitiesFrom} onChange={(e) => setActivitiesFrom(e.target.value)} />
                    <input className="form-control" type="date" value={activitiesTo} onChange={(e) => setActivitiesTo(e.target.value)} />
                  </div>
                  <div className="mt-2">
                    <button className="btn-soft btn-primary-soft" type="button" onClick={fetchActivities}>
                      <FaFilter /> Filtrar
                    </button>
                  </div>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <FaListUl /> Resultados
                  </div>

                  {activitiesLoading ? (
                    <span className="text-muted small">A carregar…</span>
                  ) : (activitiesData || []).length ? (
                    <div className="table-responsive">
                      <table className="table table-hover align-middle table-sm mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Título</th>
                            <th>Data</th>
                            <th>Hora</th>
                            <th>Escola</th>
                            <th className="text-end">Abrir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {activitiesData.map((a) => (
                            <tr key={a.meeting_id}>
                              <td className="fw-semibold">{a.meeting_title}</td>
                              <td>{a.meeting_date ? moment(a.meeting_date).format("DD/MM/YYYY") : "—"}</td>
                              <td>{(a.meeting_time || "--:--").slice(0, 5)}</td>
                              <td>{a.contact_name || "—"}</td>
                              <td className="text-end">
                                <button
                                  className="btn-soft btn-primary-soft"
                                  type="button"
                                  onClick={() => {
                                    setShowActivitiesModal(false);
                                    openDetails({
                                      ...a,
                                      meeting_contact_id: a.meeting_contact_id ? Number(a.meeting_contact_id) : null,
                                      meeting_user_ids: toNumArray(a.meeting_user_ids),
                                      meeting_status: (a.meeting_status || "agendado").toLowerCase(),
                                    });
                                  }}
                                >
                                  <FaEye /> Ver
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <span className="text-muted small">Sem resultados.</span>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="actions" style={{ width: "100%" }}>
              <Button variant="outline-secondary" className="btn-soft2" onClick={() => setShowActivitiesModal(false)}>
                Fechar
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default MeetingsAgendaTable;